import { NavigationProps } from '@amf/shared/utils/navigation';
import { useTranslate } from '@tolgee/react';
import CookiesPage, { getServerSideProps as fetcher } from '@amf/shared/pages/CookiesPage';

import Layout from 'components/layout/Layout';
import Meta from 'components/Meta';

export default function CookiesManagePage({ navigation, partners }: NavigationProps) {
  const { t } = useTranslate();
  return (
    <Layout navigation={navigation} partners={partners}>
      <Meta title={t('cookies.title')} />
      <CookiesPage />
    </Layout>
  );
}

export const getServerSideProps = fetcher();
